module.exports = __webpack_public_path__ + "img/yiyongbahen.f3403d71.png";